<template>
    <div id="app">

        <router-view></router-view>

    </div>
</template>

<script>
import { apiUrl } from '@/config.js'
export default {
    name: 'app',
    async mounted() {
        await this.$axios.get(apiUrl.replace('/api/', '/sanctum/csrf-cookie'))
    }
}
</script>

